import React from "react";

import DashboardOutlined from "@mui/icons-material/DashboardOutlined";
import EngineeringIcon from "@mui/icons-material/Engineering";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import MapIcon from "@mui/icons-material/Map";
import TerrainRoundedIcon from "@mui/icons-material/TerrainRounded";
import CallSplitRoundedIcon from "@mui/icons-material/CallSplitRounded";
import PieChartRoundedIcon from "@mui/icons-material/PieChartRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import TimelapseIcon from "@mui/icons-material/Timelapse";
import LockIcon from "@mui/icons-material/Lock";
import CheckIcon from "@mui/icons-material/Check";
import HelpIcon from "@mui/icons-material/Help";
import LogoutIcon from "@mui/icons-material/Logout";
import EmailIcon from "@mui/icons-material/Email";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import DownloadIcon from "@mui/icons-material/Download";
import ShareIcon from "@mui/icons-material/Share";
import WifiTetheringIcon from "@mui/icons-material/WifiTethering";
import CodeIcon from "@mui/icons-material/Code";
import InsightsIcon from "@mui/icons-material/Insights";
import StarBorder from "@mui/icons-material/StarBorderRounded";
import StarIcon from "@mui/icons-material/StarRounded";
import TrendingUpRoundedIcon from "@mui/icons-material/TrendingUpRounded";
import RecommendRoundedIcon from "@mui/icons-material/RecommendRounded";
import PersonAddSharpIcon from "@mui/icons-material/PersonAddSharp";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import KeyboardArrowUpRoundedIcon from "@mui/icons-material/KeyboardArrowUpRounded";
import AccountTreeRoundedIcon from "@mui/icons-material/AccountTreeRounded";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import ClearIcon from "@mui/icons-material/Clear";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AddCircleSharpIcon from "@mui/icons-material/AddCircleSharp";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import NotificationsActiveRoundedIcon from "@mui/icons-material/NotificationsActiveRounded";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import PieChartIcon from "@mui/icons-material/PieChart";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ImportContactsIcon from "@mui/icons-material/ImportContacts";
import SignalCellularAltRoundedIcon from "@mui/icons-material/SignalCellularAltRounded";
import LanguageIcon from "@mui/icons-material/Language";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

import { UpIcon, DownIcon } from "../../assets/icons";
import { ReactComponent as EYSFLogoGreyIcon } from "../../assets/icons/eysf-logo-grey.svg";
import { ReactComponent as UndrawNotifyIcon } from "../../assets/icons/undraw-notify.svg";
import SFSvgIcon from "./svgIcon";

export const SFDashboardIcon = ({ size = "sizebarNavigation", ...props }) => (
  <DashboardOutlined fontSize="sizebarNavigation" {...props} />
);

export const SFMaintenanceIcon = (props) => <EngineeringIcon {...props} />;

export const SFArrowDownWardIcon = ({ size, ...props }) => (
  <ArrowDownwardIcon fontSize={size} {...props} />
);

export const SFWifiTetheringIcon = ({ size, ...props }) => (
  <WifiTetheringIcon fontSize={size} {...props} />
);

export const SFCodeIcon = ({ size, ...props }) => (
  <CodeIcon fontSize={size} {...props} />
);

export const SFInsightsIcon = ({ size, ...props }) => (
  <InsightsIcon fontSize={size} {...props} />
);

export const SFArrowUpWardIcon = ({ size, ...props }) => (
  <ArrowUpwardIcon fontSize={size} {...props} />
);

export const SFPlayIcon = ({ size, ...props }) => (
  <PlayArrowRoundedIcon fontSize={size} {...props} />
);

export const SFPlayVideoIcon = ({ size, ...props }) => (
  <PlayCircleIcon fontSize={size} {...props} />
);

export const SFTimerIcon = ({ size, ...props }) => (
  <TimerOutlinedIcon fontSize={size} {...props} />
);

export const SFBookIcon = ({ size, ...props }) => (
  <MenuBookOutlinedIcon fontSize={size} {...props} />
);
export const SFMapIcon = ({ size, ...props }) => (
  <MapIcon fontSize={size} {...props} />
);

export const SFSustainabilityIcon = ({ size, ...props }) => (
  <TerrainRoundedIcon fontSize={size} {...props} />
);

export const SFAdaptiveSkillsIcon = ({ size, ...props }) => (
  <CallSplitRoundedIcon fontSize={size} {...props} />
);

export const SFDataAndAnalyticsSkillsIcon = ({ size, ...props }) => (
  <PieChartRoundedIcon fontSize={size} {...props} />
);

export const SFMyProgressIcon = ({ size, ...props }) => (
  <PieChartIcon fontSize={size} {...props} />
);

export const SFCompletedIcon = ({ size, ...props }) => (
  <CheckCircleRoundedIcon fontSize={size} {...props} />
);

export const SFCloseIcon = ({ size, ...props }) => (
  <CloseIcon fontSize={size} {...props} />
);

export const SFInfoIcon = ({ size, ...props }) => (
  <InfoOutlinedIcon fontSize={size} {...props} />
);

export const SFTimelapseIcon = ({ size, ...props }) => (
  <TimelapseIcon fontSize={size} {...props} />
);

export const SFLockIcon = ({ size, ...props }) => (
  <LockIcon fontSize={size} {...props} />
);

export const SFCheckIcon = ({ size, ...props }) => (
  <CheckIcon fontSize={size} {...props} />
);

export const SFHelpIcon = ({ size, ...props }) => (
  <HelpIcon fontSize={size} {...props} />
);

export const SFLogoutIcon = ({ size, ...props }) => (
  <LogoutIcon fontSize={size} {...props} />
);

export const SFEmailIcon = ({ size, ...props }) => (
  <EmailIcon fontSize={size} {...props} />
);

export const SFMoreHorizIcon = ({ size, ...props }) => (
  <MoreHorizIcon fontSize={size} {...props} />
);

export const SFDownloadIcon = ({ size, ...props }) => (
  <DownloadIcon fontSize={size} {...props} />
);

export const SFShareIcon = ({ size, ...props }) => (
  <ShareIcon fontSize={size} {...props} />
);

export const SFStarIcon = (props) => {
  return <StarIcon color={props.color} fontSize={props.size} {...props} />;
};

export const SFStarBorderIcon = (props) => {
  return <StarBorder color={props.color} fontSize={props.size} {...props} />;
};

export const SFTrendingUpIcon = (props) => {
  return <TrendingUpRoundedIcon color={props.color} fontSize={props.size} {...props} />;
};

export const SFRecommendIcon = (props) => {
  return <RecommendRoundedIcon color={props.color} fontSize={props.size} {...props} />;
};

export const SFPersonAddIcon = (props) => {
  return <PersonAddSharpIcon color={props.color} fontSize={props.size} {...props} />;
};

export const SFArrowDownRoundedIcon = (props) => {
  return <KeyboardArrowDownRoundedIcon color={props.color} fontSize={props.size} {...props} />;
};

export const SFArrowUpRoundedIcon = (props) => {
  return <KeyboardArrowUpRoundedIcon color={props.color} fontSize={props.size} {...props} />;
};

export const SFAccountTreeIcon = (props) => {
  return (
    <AccountTreeRoundedIcon
      color={props.color}
      fontSize={props.size}
      {...props}
    />
  );
};

export const SFUpIcon = (props) => {
  return <SFSvgIcon {...props}>{UpIcon}</SFSvgIcon>;
};

export const SFDownIcon = (props) => {
  return <SFSvgIcon {...props}>{DownIcon}</SFSvgIcon>;
};

export const SFSearchIcon = (props) => {
  return <SearchIcon color={props.color} fontSize={props.size} />;
};

export const SFFilterListIcon = (props) => {
  return <FilterListIcon color={props.color} fontSize={props.size} />;
};

export const SFArrowDownIcon = (props) => {
  return (
    <KeyboardArrowDownIcon
      color={props.color}
      fontSize={props.size}
      {...props}
    />
  );
};

export const SFArrowUpIcon = (props) => {
  return <KeyboardArrowUpIcon color={props.color} fontSize={props.size} />;
};

export const SFCheckboxUnchecked = (props) => {
  return <CheckBoxOutlineBlankIcon color={props.color} fontSize={props.size} />;
};

export const SFCheckboxChecked = (props) => {
  return <CheckBoxIcon color={props.color} fontSize={props.size} />;
};

export const SFClearIcon = (props) => {
  return <ClearIcon color={props.color} fontSize={props.size} {...props} />;
};

export const SFRemoveCircleIcon = (props) => {
  return <RemoveCircleIcon color={props.color} fontSize={props.size} />;
};

export const SFRadioButtonCheckedIcon = (props) => (
  <RadioButtonCheckedIcon color={props.color} fontSize={props.size} />
);

export const SFRadioButtonUncheckedIcon = (props) => (
  <RadioButtonUncheckedIcon color={props.color} fontSize={props.size} />
);

export const SFCheckCircleIcon = (props) => (
  <CheckCircleIcon color={props.color} fontSize={props.size} />
);

export const SFAddCircleIcon = (props) => (
  <AddCircleSharpIcon color={props.color} fontSize={props.size} />
);

export const SFMoreVertIcon = (props) => (
  <MoreVertIcon color={props.color} fontSize={props.size} />
);

export const SFInfoRoundedIcon = (props) => (
  <InfoRoundedIcon fontSize={props.size} {...props} />
);
export const SFNotificationIcon = (props) => (
  <NotificationsActiveRoundedIcon fontSize={props.size} {...props} />
);
export const SFWarningIcon = (props) => (
  <WarningRoundedIcon fontSize={props.size} {...props} />
);
export const SFErrorIcon = (props) => (
  <ErrorRoundedIcon fontSize={props.size} {...props} />
);
export const SFVisibilityIcon = (props) => (
  <VisibilityIcon fontSize={props.size} {...props} />
);

export const SFImportContactsIcon = (props) => (
  <ImportContactsIcon fontSize={props.size} {...props} />
);

export const SFSignalCellularAltRoundedIcon = (props) => (
  <SignalCellularAltRoundedIcon fontSize={props.size} {...props} />
);

export const SFLanguageIcon = (props) => (
  <LanguageIcon fontSize={props.size} {...props} />
);

export const SFArrowRightIcon = (props) => (
  <ArrowRightIcon fontSize={props.size} {...props} />
);

export const SFEYSFLogoGreyIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={EYSFLogoGreyIcon} {...props} />;
};

export const SFUndrawNotifyIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={UndrawNotifyIcon} {...props} />;
};
